import type { FunctionComponent } from 'react';

import { format, isBefore, subHours } from 'date-fns';

import type { UpcomingEventCountdownProps } from './UpcomingEventCountdown';
import { UpcomingEventCountdown } from './UpcomingEventCountdown';

type UpcomingEventDateDisplayMode = 'date' | 'countdown';

interface UpcomingEventDateBaseProps {
  date: Date;
  countdownOptions?: Omit<UpcomingEventCountdownProps, 'date'>;
}

interface UpcomingEventDateWithAutomaticCountdownCutoffProps extends UpcomingEventDateBaseProps {
  countdownCutoffIntervalHours: number;
}

interface UpcomingEventDateWithExplicitModeProps extends UpcomingEventDateBaseProps {
  mode: UpcomingEventDateDisplayMode;
}

type UpcomingEventDateProps =
  | UpcomingEventDateWithAutomaticCountdownCutoffProps
  | UpcomingEventDateWithExplicitModeProps;

const UpcomingEventDate: FunctionComponent<UpcomingEventDateProps> = ({
  date,
  countdownOptions,
  ...rest
}) => {
  const countdownCutoffIntervalHours =
    'countdownCutoffIntervalHours' in rest ? rest.countdownCutoffIntervalHours : 0;

  const displayCountdown =
    ('mode' in rest && rest.mode === 'countdown') ||
    isBefore(subHours(date, countdownCutoffIntervalHours), Date.now());

  return displayCountdown ? (
    <UpcomingEventCountdown date={date} {...countdownOptions} />
  ) : (
    format(date, 'dd.MM.yy, HH:mm')
  );
};

export { UpcomingEventDate };
